import React, { useEffect } from 'react';
import { Screen } from '../types';
import arunachalLogo from '../../../assets/Arunachal-Pradesh.png';

const SplashScreen = ({ navigateTo }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      navigateTo(Screen.Home);
    }, 2500);
    return () => clearTimeout(timer);
  }, [navigateTo]);

  return (
    <div className="ilp-splash">
      <div className="ilp-splash-glow"></div>
      <div className="ilp-splash-content">
        <div className="ilp-splash-logo animate-entrance">
          <img src={arunachalLogo} alt="Arunachal Pradesh" />
        </div>
        <div className="ilp-splash-text animate-fade-in-up">
          <h1>eILP Arunachal</h1>
          <div className="ilp-splash-divider">
            <span></span>
            <p>Digital Gateway</p>
            <span></span>
          </div>
        </div>
        <div className="ilp-splash-loader">
          <div className="ilp-loader-bar"></div>
        </div>
      </div>
      <div className="ilp-splash-footer animate-fade-in">
        <p>Department of IT & Communication</p>
        <p>Government of Arunachal Pradesh</p>
      </div>
    </div>
  );
};

export default SplashScreen;

